// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1LgW-","notes":"Notes_notes__3S9vT","note":"Notes_note__3Ddcx","markdown":"Notes_markdown__2Pe6F"};